import { ArrowUp } from 'lucide-react'

interface Props {
  count: number
  onClick: () => void
}

/**
 * Floating "X new alerts since you opened" pill that appears when the user
 * is scrolled away from the top and new alerts have arrived. Click to flush
 * the buffer + scroll to top.
 */
export function NewAlertsToast({ count, onClick }: Props) {
  if (count === 0) return null
  return (
    <button
      type="button"
      onClick={onClick}
      className="absolute left-1/2 top-2 z-20 flex -translate-x-1/2 items-center gap-1 rounded-full bg-primary px-3 py-1 text-xs font-medium text-primary-fg hover:bg-primary/90 animate-in fade-in-0 slide-in-from-top-1"
    >
      <ArrowUp size={12} />
      {count > 9 ? '9+' : count} new alert{count === 1 ? '' : 's'} since you opened
    </button>
  )
}
